/**
 * 占位页:基座(008.1)只搭路由骨架,具体业务页由 008.2~008.6 实现。
 * 用真实空态块呈现「建设中」,**不留死按钮 / 不伪造交互**(NO AI SLOP)。
 * 各页接手时替换为真实实现。
 */
interface PlaceholderPageProps {
  title: string;
  /** 对应 WScreen-N(web-pages 全集),便于接手时定位规格。 */
  screen: string;
  /** 实现该屏的 story(epic-20)。 */
  story: string;
}

export function PlaceholderPage({ title, screen, story }: PlaceholderPageProps) {
  return (
    <div className="inner section">
      <div className="state">
        <div className="ic">🏗️</div>
        <h2 className="h2 mb-3">{title}</h2>
        <p className="muted sm">
          {screen} · 该页面将在 {story} 交付。基座(008.1)已搭好外壳、数据层与会话。
        </p>
      </div>
    </div>
  );
}
